// extracted by mini-css-extract-plugin
module.exports = {"bleed--true":"BUIProvider-module__bleed--true___agLZI","bleed--0":"BUIProvider-module__bleed--0___8G9ZO"};